import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./optanonWrapper";
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import "reactjs-popup/dist/index.css";
import "./ressources/styles/styles.scss";
import "./translations/translations";
import { persistor, store } from "store/configureStore";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { BrowserRouter, Route, Router } from "react-router-dom";
import SplashScreen from "components/SplashScreen/SplashScreen";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import { createBrowserHistory } from "history";
const history = createBrowserHistory();
export const SentryRoute = Sentry.withSentryRouting(Route);

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.REACT_APP_INSTANCE,
  sampleRate: process.env.REACT_APP_SENTRY_SAMPLERATE,
  replaysSessionSampleRate:
    process.env.REACT_APP_SENTRY_REPLAY_SESSION_SAMPLERATE,
  replaysOnErrorSampleRate:
    process.env.REACT_APP_SENTRY_REPLAY_ERROR_SAMPLERATE,
  tracesSampleRate: process.env.REACT_APP_SENTRY_TRACE_SAMPLERATE,
  integrations: [
    new Sentry.Replay(),
    new BrowserTracing({
      tracePropagationTargets: ["localhost", process.env.REACT_APP_DOMAIN, /^\//],
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
  ],
  beforeSend(event, hint) {
    event.logger = "React";
    return event;
  },
});

ReactDOM.render(
  // Suspense is mainly used to display a fallback while translations are still loading
  <Suspense fallback={<SplashScreen />}>
    <I18nextProvider i18n={i18next}>
      <Provider store={store}>
        <PersistGate persistor={persistor}>
          <Router history={history}>
            <App />
          </Router>
        </PersistGate>
      </Provider>
    </I18nextProvider>
  </Suspense>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// servieroweker.unregister();
serviceWorker.register();
